// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"653e728e","239":"692345e3","240":"36de8bc0","318":"d9b19da8","455":"7b40c207","637":"6bfece10","675":"fe0832e7","719":"42184d1a"}[chunkId] + ".chunk.js";
};